<template>
  <div class="listDataWrapper">
    <div class="listData">
      <router-link :to="{ name: 'categories.edit', params: { id: category.id }}" class="listData__link" @click="setSize()">
        <div class="listData__item">
          <h3 class="listData__heading mb0">
            <font-awesome-icon :icon="['fal', 'chevron-right']" v-if="child"/>
            {{ category.languages[language].title }}
          </h3>
        </div>
      </router-link>
      <button class="listData__delete" @click="deleteCategory(category)">
        <font-awesome-icon :icon="['fal', 'trash-alt']"/>
      </button>
    </div>
    <div class="listDataChild">
      <CategoryItem v-for="subCategory in category.subCategories" :category="subCategory" :key="subCategory.id" :child="true" />
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types.js'
import CategoryItem from './CategoryItem'
import {deleteResource} from '@/helpers/resource'

export default {
  name: 'CategoryItem',
  props: ['category', 'child'],
  components: {
    CategoryItem
  },
  computed: {
    language () {
      return this.$store.getters[types.DEFAULT_LANGUAGE]
    }
  },
  methods: {
    deleteCategory (category) {
      deleteResource(types.REMOVE_CATEGORY, category)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Category/CategoryItem.vue